import React, { PureComponent } from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import renderImageSelector from '../../../shared/components/form/ImageSelector';
import {withTranslation} from "react-i18next";

const themes = [
  { image: `${process.env.PUBLIC_URL}/img/themes/clean-blog.png`, value: 'clean-blog', name: "Clean blog" },
  { image: `${process.env.PUBLIC_URL}/img/themes/magazine.png`, value: 'magazine', name: "Magazine" },
  { image: `${process.env.PUBLIC_URL}/img/themes/stellar.png`, value: 'stellar', name: "Stellar" },
  { image: `${process.env.PUBLIC_URL}/img/themes/strata.png`, value: 'strata', name: "Strata" },
  { image: `${process.env.PUBLIC_URL}/img/themes/editorial.png`, value: 'editorial', name: "Editorial" },
  { image: `${process.env.PUBLIC_URL}/img/themes/imperfect.png`, value: 'imperfect', name: "Imperfect" }
];

class ThemeSettings extends PureComponent {

  render() {
    const { handleSubmit, t } = this.props;

    return (
      <Col xs={12} md={12} lg={12} xl={12}>
        <Card>
          <CardBody>
          <div className="card__title">
              <h5 className="bold-text">{t('settings.theme.title')}</h5>
            </div>
            <form className="form form--horizontal" onSubmit={handleSubmit}>
              <div className="form__form-group">
                <div className="form__form-group">
                <Field 
                  name="theme" 
                  component={renderImageSelector} 
                  options={themes} /> 
                </div>
              </div>
            </form>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default reduxForm({
  form: 'blog_settings'
})(withTranslation('dashboard')(ThemeSettings));
